<template>
  <el-dialog
    :title="title"
    append-to-body
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    top="15vh"
  >
    <div class="layout" :style="{height: `${418/scale}px`}">
      <SearchSelect
        @onRemove="handleTagRemove"
        @onAdd="handleTagAdd"
        :isHeadimg="isHeadimg"
        :selectList="selectList"
        queryType="role" />
      <div class="operate">
        <el-row>
          <el-button type="primary" @click="handleConfirm">确定</el-button>
          <el-button type="info" plain @click="handleClose">取消</el-button>
        </el-row>
      </div>
      <div class="right">
        <TreeRole
          height="314"
          :isAccount="false"
          :count="roleCount"
          :selectList="selectList"
          @onToggle="handleToggle"
          @onAll="handleAll"
          :home="currentTenant"
          :isHeadimg="isHeadimg" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import SearchSelect from './searchSelect'
import TreeRole from './TreeRole'
import Item from './item'
import currentTenant from './mixins/currentTenant'
import mixScale from './mixins/scale'
import mixSelectList from './mixins/selectList'

export default {
  mixins: [currentTenant, mixScale, mixSelectList],
  provide: function() {
    return {
      multiple: this.multiple
    }
  },
  components: {
    TreeRole,
    Item,
    SearchSelect
  },
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    selectedItems: {
      type: Array
    },
    title: {
      type: String,
      default: '选择角色'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isHeadimg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roleCount: {}
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('onChecked', [
        ...this.selectList
      ])
      this.handleClose()
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './dialog.scss'
</style>
